import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  get(id) {
    return axios.get(adminPath(`/compliance_documents/${id}`)).then((response) => an('ComplianceDocument', response.data));
  },
  getComplianceDocuments(params) {
    return axios.get(adminPath('/compliance_documents?') + prepareQueryString(params)).then((response) => {
      return {
        complianceDocuments: response.data.map((complianceDocument) =>
          an('ComplianceDocument', complianceDocument)
        ),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/compliance_documents/${id}`), {
        ...data,
      })
      .then((response) => an('ComplianceDocument', response.data));
  },
  create(userId, data) {
    return axios
      .post(adminPath(`/users/${userId}/compliance_documents`), {
        ...data,
      })
      .then((response) => an('ComplianceDocument', response.data));
  },
  getReminderFrequencyOptions() {
    return axios.get(adminPath('/compliance_documents/reminder_frequency_options'));
  },
  getCategoryOptions() {
    return axios.get(adminPath('/compliance_documents/category_options'));
  },
  getDocumentTypeOptions() {
    return axios.get(adminPath('/compliance_documents/document_type_options'));
  },
  getStatusOptions() {
    return axios.get(adminPath('/compliance_documents/status_options'));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/compliance_documents.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
};
